<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="480"
        persistent @keydown.esc="chiudi">
        <v-card v-if="pagamento">
            <v-card-title class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-cash-check</v-icon>
                <div>
                    <div>Segna come pagato</div>
                    <div class="text-caption text-medium-emphasis font-weight-regular">
                        {{ pagamento.tipoPagamentoNome }} — {{ formattaImporto(pagamento.importo) }}
                    </div>
                </div>
            </v-card-title>

            <v-card-text>
                <!-- NOTA: l'upload dell'allegato fattura/ricevuta non è stato implementato in
                     questa fase (vedi Pagamento.Allegati lato backend): richiederebbe un
                     endpoint /allegati/pagamento/{id} dedicato non garantito dal contratto
                     API fornito. Il pattern (api.allegati.js + upload_allegato_*) è pronto
                     per essere replicato in un secondo momento. -->
                <v-text-field v-model="dataPagamento" type="date" label="Data pagamento" :max="oggiIso"
                    :rules="[v => !!v || 'Campo obbligatorio']" />
                <v-textarea v-model="note" label="Note" rows="2" />

                <v-alert v-if="pagamento.ricorrente" type="info" variant="tonal" density="comfortable"
                    class="rounded-lg">
                    <div class="font-weight-medium">Pianificazione ricorrente</div>
                    <div class="text-body-2">
                        Verrà generato un nuovo pagamento in fondo alla serie, mantenendo pieno l'orizzonte
                        di anni configurato per l'azienda.
                    </div>
                </v-alert>
                <div v-else class="text-caption text-medium-emphasis">
                    Se la tipologia ha una frequenza configurata, alla conferma verrà generato automaticamente
                    un solo prossimo pagamento, con scadenza calcolata dalla data di pagamento effettiva.
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="success" :loading="salvataggio" @click="completa">Conferma pagamento</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogCompletaPagamento",

    props: {
        modelValue: { type: Boolean, default: false },
        pagamento: { type: Object, default: null },
    },
    emits: ["update:modelValue", "completato"],

    data() {
        return {
            dataPagamento: this.oggiLocale(),
            note: "",
            salvataggio: false,
        };
    },

    computed: {
        oggiIso() {
            return this.oggiLocale();
        },
    },

    watch: {
        modelValue(val) {
            if (val) {
                this.dataPagamento = this.oggiLocale();
                this.note = "";
            }
        },
    },

    methods: {
        // Data locale (non toISOString: in UTC sposterebbe il giorno vicino alla mezzanotte).
        oggiLocale() {
            const d = new Date();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${d.getFullYear()}-${m}-${g}`;
        },

        formattaImporto(importo) {
            return importo != null
                ? importo.toLocaleString("it-IT", { style: "currency", currency: "EUR" })
                : "—";
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },

        async completa() {
            if (!this.dataPagamento) return;
            this.salvataggio = true;
            try {
                await this.$store.dispatch("pagamenti/completa", {
                    id: this.pagamento.id,
                    dati: {
                        dataEsecuzione: this.dataPagamento,
                        notePagamento: this.note,
                    },
                });
                this.$emit("completato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },
    },
};
</script>
